export const INPUT_REPLACE_TYPES = {
  PHONE: 'PHONE',
  CURRENCY: 'CURRENCY',
  PERCENT: 'PERCENT',
  TRIM: 'TRIM',
};
